/// <reference path="../DashboardViewer/DashboardViewer.ts" />

declare var GridStack: any;

namespace Matrix.Dashboards {

    export const defaultWidgetCols = 4;
    export const defaultWidgetRows = 3;
    export const minWidgetRows = 2;

    @Serenity.Decorators.registerClass()
    export class DashboardEditor extends DashboardViewer {

        constructor(container: JQuery, opt: any) {
            super(container, opt);

            container.removeClass('dashboard-viewing').addClass('dashboard-editing');

            if (this.canDragWidgets) {
                var input = this.searchInput;
                new Serenity.QuickSearchInput(input, {
                    onSearch: (field, term, done) => {
                        done(true);

                        term = Select2.util.stripDiacritics(Q.trim((term || '').toLowerCase()));
                        if (!term.length) {
                            this.addWidgetCol.children('.add-widget-item.hidden').removeClass('hidden');
                            return;
                        }

                        this.addWidgetCol.children('.add-widget-item').each((i, el) => {
                            var text = Select2.util.stripDiacritics(Q.trim((el.textContent ?? '').toLowerCase()));
                            var match = text.indexOf(term) >= 0;
                            el.classList.toggle('hidden', !match)
                        });

                    }
                });
                input.attr('placeholder', 'search widgets...');

                this.gridStack.on('dropped', (e, previousWidget: any, newWidget: any) => {
                    var $el = $(newWidget.el).removeClass('add-widget-item').removeClass('dashboard-widget-drag-in');
                    var id = 'item_' + (this.nextId++).toString();
                    $el.attr('gs-id', id);
                    newWidget.id = id;
                    this.recreateWidgetOn($el);
                });
            }
        }

        protected getGridStackOptions() {
            return Q.extend(super.getGridStackOptions(), {
                acceptWidgets: this.canDragWidgets(),
                removeTimeout: 100,
                staticGrid: false
            });
        }

        protected get searchInput() {
            return $('#' + this.uniqueName + "_Search");
        }

        protected get addWidgetCol() {
            return $('.add-widget-col', this.element);
        }

        protected getTemplate() {
            return this.canDragWidgets() ? `<div class="row">
    <div class="col-md-2 add-widget-col">
        <div class="search-widgets">
            <input type="text" id="${this.uniqueName}_Search" placeholder="search widgets..." />
        </div>
    </div>
    <div class="col-sm-12 col-md-10">
        ${super.getTemplate()}
    </div>
</div>` : super.getTemplate();
        }

        protected addWidgetItem (key: string, name: string, icon: string, cols: number, rows: number, opt: any, addCol?: JQuery) {
            return $(
            `<div class="grid-stack-item add-widget-item dashboard-widget-drag-in" 
    gs-w="${cols || defaultWidgetCols}" gs-min-h=${minWidgetRows} gs-h="${rows || defaultWidgetRows}" 
    data-widget="${Q.attrEncode(key)}" data-options="${Q.attrEncode(JSON.stringify(opt || {}))}">
<div class="grid-stack-item-content">
    <i class="add-widget-icon ${Q.attrEncode(icon)}" role="img" aria-label="${Q.attrEncode(name)}"></i>
    <span class="add-widget-name">${Q.htmlEncode(name)}</span>
</div>
</div>`).appendTo(addCol || this.addWidgetCol);
        }

        protected updateCatalogWidgets() {

            var addCol = this.addWidgetCol;
            addCol.children('.catalog-widget').remove();
            this.searchInput.val('');

            WidgetCatalogService.List({
                ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                IncludeColumns: [
                    WidgetCatalogRow.Fields.Name,
                    WidgetCatalogRow.Fields.WidgetType,
                    WidgetCatalogRow.Fields.Properties
                ],
                Sort: [WidgetCatalogRow.Fields.Name],
            },
                response => {

                    for (var cat of response.Entities) {
                        var item = this.widgetTypeLookup.itemById[cat.WidgetType];
                        if (item != null)
                            this.addWidgetItem(item.Key, cat.Name, item.Icon, cat.Properties?.LayoutW, cat.Properties?.LayoutH, cat.Properties?.WidgetOptions, addCol)
                                .addClass('catalog-widget');
                    }

                    GridStack.setupDragIn('.dashboard-widget-drag-in', {
                        revert: 'invalid',
                        scroll: false,
                        appendTo: 'body',
                        helper: 'clone'
                    });
                });
        }

        protected widgetTypesLoaded() {

            if (this.canDragWidgets) {
                var addCol = $('.add-widget-col', this.element);

                for (var item of this.widgetTypeLookup.items) {

                    var opt: any = {};
                    if (item.Options)
                        for (var prop of item.Options)
                            if (prop.defaultValue != null)
                                opt[prop.name] = prop.defaultValue;

                    this.addWidgetItem(item.Key, item.Name, item.Icon, item.Cols, item.Rows, opt, addCol);
                }

                this.updateCatalogWidgets();
            }

            this.element.on('click', '.edit-widget-options', e => {
                this.openDesignerFor($(e.target).closest('.grid-stack-item'));
            });

            if (this.canAddToCatalog()) {
                this.element.on('click', '.add-widget-to-catalog', e => {
                    this.addWidgetToCatalog($(e.target).closest('.grid-stack-item'));
                });
            }

            if (this.canRemoveWidgets()) {
                this.element.on('click', '.remove-widget', e => {
                    this.removeWidget($(e.target).closest('.grid-stack-item'));
                });
            }

            super.widgetTypesLoaded();
        }

        getWidgetTypeItemFrom(el: JQuery): WidgetTypeItem {
            var typeKey = el.attr('data-widget');
            if (!typeKey)
                return null;

            return this.widgetTypeLookup.itemById[typeKey];
        }

        getWidgetTypeFrom(el: JQuery): any {
            var widgetTypeItem = this.getWidgetTypeItemFrom(el);

            if (!widgetTypeItem || !widgetTypeItem.ScriptType)
                return null;

            return Q.getType(widgetTypeItem.ScriptType);
        }

        renderWidgetOn(el: JQuery, widgetTypeKey: string, options: any) {
            el.attr('data-widget', widgetTypeKey);
            el.attr('data-options', JSON.stringify(options));
            this.recreateWidgetOn(el);
        }

        recreateWidgetOn(el: JQuery) {

            var container = el.children('.grid-stack-item-content').html('');

            if (this.canRemoveWidgets() && !el.children('.remove-widget').length)
                $('<a class="remove-widget" title="remove widget"/>').appendTo(el);

            var widgetTypeItem = this.getWidgetTypeItemFrom(el);

            if (!el.children('.widget-type-hint').length)
                $(`<span class="widget-type-hint">${widgetTypeItem != null ?
                    Q.htmlEncode(widgetTypeItem.Name) : (el.attr('data-widget'))} <i class="${Q.attrEncode(
                        widgetTypeItem != null ? widgetTypeItem.Icon : 'fa fa-question')}"></i></span>`).appendTo(el);

            if (!widgetTypeItem || !widgetTypeItem.ScriptType)
                return;

            if (!el.children('.edit-widget-options').length)
                $('<a class="edit-widget-options" title="edit options"/>').appendTo(el);

            if (this.canAddToCatalog() && !el.children('.add-widget-to-catalog').length)
                $('<a class="add-widget-to-catalog" title="add widget to catalog"/>').appendTo(el);

            var widgetType = Q.getType(widgetTypeItem.ScriptType) as any;
            if (widgetType == null)
                return;

            var options = JSON.parse(el.attr('data-options') || '{}') as IWidgetOptions;
            options.__designer = {
                openDesigner: (propertyName: string) => this.openDesignerFor(el, propertyName)
            };

            this.createWidgetTitleAndBody(container, widgetType, options);
        }

        getBindingKeys() {
            var bindingKeys = [];
            $('.grid-stack-item[data-options]', this.element).each((i, el) => {
                var optJson = $(el).attr('data-options');
                if (!optJson || !Q.startsWith(optJson, '{') || !Q.endsWith(optJson, '}'))
                    return;
                var opt = JSON.parse(optJson);
                for (var d of Object.keys(opt).filter(x => Q.endsWith(x, paramBindingsSuffix) && opt[x] != null).map(x => opt[x])) {
                    for (var k of Object.keys(d)) {
                        bindingKeys.push(d[k]);
                    }
                }
            });

            return bindingKeys.filter((v, i, a) => a.indexOf(v) === i);
        }

        openDesignerFor(el: JQuery, propertyName?: string) {

            var widgetTypeItem = this.getWidgetTypeItemFrom(el);
            if (widgetTypeItem == null)
                return;

            var designerType = Q.getType(widgetTypeItem.ScriptType + "Designer") as any;

            var dlg = new WidgetDesignerDialog({
                widgetTypeItem: widgetTypeItem,
                data: JSON.parse(el.attr('data-options') || '{}'),
                designer: designerType != null ? new designerType() : null,
                getBindingKeys: this.getBindingKeys.bind(this)
            });

            dlg.onOkClick = (data) => {
                dlg.dialogClose();
                el.attr('data-options', JSON.stringify(data || {}));
                this.recreateWidgetOn(el);
                this.element.triggerHandler('widgetModified');
            };

            dlg.dialogOpen();
        }


        addWidgetToCatalog(el: JQuery) {

            var widgetTypeKey = el.attr('data-widget');
            var opt = JSON.parse(el.attr('data-options') || "{}");

            var dlg = new WidgetCatalogDialog();
            Serenity.SubDialogHelper.bindToDataChange(dlg, this, () => {
                this.updateCatalogWidgets();
            });
            dlg.loadEntityAndOpenDialog({
                Name: opt?.Title,
                WidgetType: widgetTypeKey,
                Properties: {
                    WidgetOptions: opt,
                    LayoutW: Q.toId(el.attr('gs-w')),
                    LayoutH: Q.toId(el.attr('gs-h'))
                }
            });

            dlg.dialogOpen();
        }


        removeWidget(el: JQuery) {
            if (!el || !el.length)
                return;
            var options = $(el).attr('data-options');
            if (options && Q.trim(options) != "{}") {
                Q.confirm('Remove this widget?', () => this.gridStack.removeWidget(el[0]));
            }
            else
                this.gridStack.removeWidget(el[0]);
        }

        getValue(): DashboardItem[] {
            if (!this.widgetTypeLookup)
                return this.loadedItems || [];

            var byId: Q.Dictionary<JQuery> = {};
            (this.gridStack.getGridItems() as HTMLElement[]).forEach(el => {
                var $el = $(el);
                var id = $el.attr('gs-id');
                if (id != null)
                    byId[id] = $el;
            });

            var result = this.gridStack.save(false).map(gi => {
                if (gi.id == null)
                    return null;
                var div = byId[gi.id];
                if (div == null)
                    return null;

                var collapsed = !!div.hasClass('collapsed-widget');
                var h = Math.max(minWidgetRows, (collapsed ? (Q.toId(div.attr('gs-h-org')) || gi.h) : gi.h) || defaultWidgetRows);

                return <DashboardItem>{
                    LayoutX: gi.x,
                    LayoutY: gi.y,
                    LayoutW: gi.w,
                    LayoutH: h,
                    Collapsed: collapsed,
                    WidgetType: div.attr('data-widget'),
                    WidgetOptions: JSON.parse(div.attr('data-options') || "{}")
                };
            }).filter(x => x != null);

            return result;
        }

        protected canRemoveWidgets() {
            return true;
        }

        protected canDragWidgets() {
            return true;
        }

        protected canAddToCatalog() {
            return true;
        }
    }
}